module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Gamepad#2-fa15aa710f75b73d23e4a771f3c02d9e.svg";